import ProcForm from "@/assets/models/ProcForm";

let nodeBase = ['start', 'tianxieForm', 'yunyingjingliShenpi', 'zhuguanShenpi', 'zongcaiShenpi', 'caiwuShenpi', 'zongjingbanShenpi', 'chunaFukuan', 'zhuguanQueren', 'end'];
let nodeBase1 = ['start', 'tianxieForm', 'yunyingjingliShenpi', 'zhuguanShenpi', 'caiwuShenpi', 'zongjingbanShenpi', 'chunaFukuan', 'zhuguanQueren', 'end'];
let nodeGzSbGjj = ['start', 'tianxieForm', 'caiwuShenpi', 'zongjingbanShenpi', 'end'];
let nodeJiesuan = ['start', 'tianxieForm', 'zhuguanShenpi', 'end'];

let apiReSubmitFormFk = '/sp/tianxieForm/finish'
let apiSubmitFormFk = '/sp/start-fk'
let apiSubmitFormBx = '/sp/start-bx'
// '发起申请'弹窗所有按钮
let Info = [
    {
        title: '付款申请',
        btns: [{
            subTitle: '付款申请', // 流程小标题
            imgIcon: '/images/钱.svg', // 流程对应icon
            node: nodeBase, // 流程所有节点
            apiSubmitForm: apiSubmitFormFk, // 创建流程api
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'], // 流程需要校验的表单字段
            useForm: ProcForm.fukuan, // 流程所使用到的表单字段
        }, {
            subTitle: '日常采购',
            imgIcon: '/images/付款申请表单.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormFk,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '服务器充值',
            imgIcon: '/images/会议费.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormFk,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '服务器购买',
            imgIcon: '/images/会议费.svg',
            node: nodeBase1.concat('serverBuy'),
            apiSubmitForm: '/sp/start-server-buy',
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '服务器续费',
            imgIcon: '/images/会议费.svg',
            node: nodeBase1.concat('serverBuy'),
            apiSubmitForm: '/sp/start-server-xufei',
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '推广申请',
            imgIcon: '/images/事情申请表单复制.svg',
            node: nodeBase1.concat('tuiguangStart', 'yunyingjingliShenpi', 'yunyingzuzhangShenpi'),
            apiSubmitForm: '/sp/start-tuiguang',
            apiReSubmitForm: '/sp/tianxieForm-tuiguang/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name', 'yunyingzuzhangUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '租金水电',
            imgIcon: '/images/资产相关表单.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormFk,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '供应链采购',
            imgIcon: '/images/供应商费用申请表单.svg',
            node: nodeBase1.concat('tianxieCaigouForm', 'zhuguanShenpiCaigou', 'zongjingbanShenpiCaigou', 'huowuQianshou'),
            apiSubmitForm: '/sp/start-gyl',
            apiReSubmitForm: '/sp/tianxieForm-gyl/finish',
            needValidFormField: ['jine', 'zhuguanUser.name', 'zhuguanUserCaigou.name', 'zongjingbanUserCaigou.name', 'qianshouUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '物流费结算',
            imgIcon: '/images/物流.svg',
            node: nodeBase1,
            apiSubmitForm: apiSubmitFormFk,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'kuanxiangsGz.jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '物流费充值',
            imgIcon: '/images/物流.svg',
            node: nodeBase1,
            apiSubmitForm: apiSubmitFormFk,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '部门货款结算',
            imgIcon: '/images/部门款结算.svg',
            node: nodeBase1,
            apiSubmitForm: apiSubmitFormFk,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '工资',
            imgIcon: '/images/工资.svg',
            node: nodeGzSbGjj,
            apiSubmitForm: '/sp/start-gz',
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['jine', 'kuanxiangsGz.jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '社保',
            imgIcon: '/images/社保.svg',
            node: nodeGzSbGjj,
            apiSubmitForm: '/sp/start-gz',
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['jine', 'kuanxiangsGz.jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }, {
            subTitle: '公积金',
            imgIcon: '/images/公积金.svg',
            node: nodeGzSbGjj,
            apiSubmitForm: '/sp/start-gz',
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['jine', 'kuanxiangsGz.jine', 'zhuguanUser.name'],
            useForm: ProcForm.fukuan,
        }]
    },
    {
        title: '报销申请',
        btns: [{
            subTitle: '日常报销',
            imgIcon: '/images/通用报销表单.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormBx,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['lingkuanren', 'yongtus.jine', 'yongtus.name', 'zhuguanUser.name'],
            useForm: ProcForm.baoxiao,
        }, {
            subTitle: '备用金申请',
            imgIcon: '/images/通用报销表单.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormBx,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['lingkuanren', 'yongtus.jine', 'yongtus.name', 'zhuguanUser.name'],
            useForm: ProcForm.baoxiao,
        }, {
            subTitle: '推广费报销',
            imgIcon: '/images/通用报销表单.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormBx,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['lingkuanren', 'yongtus.jine', 'yongtus.name', 'zhuguanUser.name'],
            useForm: ProcForm.baoxiao,
        }, {
            subTitle: '下午茶聚餐报销',
            img: '报销申请-下午茶聚餐报销',
            imgIcon: '/images/通用报销表单.svg',
            node: nodeBase,
            apiSubmitForm: apiSubmitFormBx,
            apiReSubmitForm: apiReSubmitFormFk,
            needValidFormField: ['lingkuanren', 'yongtus.jine', 'yongtus.name', 'zhuguanUser.name'],
            useForm: ProcForm.baoxiao,
        }]
    },
    {
        title: '其他',
        btns: [{
            subTitle: '样品采购',
            imgIcon: '/images/付款申请表单.svg',
            node: ['start', 'tianxieForm', 'zhuguanShenpi', 'caigouQueren', 'caiwuShenpi', 'chunaFukuan', 'huitianyangpindanhao', 'end'],
            apiSubmitForm: '/sp/start-ypcg',
            apiReSubmitForm: '/sp/tianxieForm-ypcg/finish',
            needValidFormField: ['caigouUser.name'],
            useForm: ProcForm.yangpincaigouBeihuoshenqing,
        }, {
            subTitle: 'FBA备货申请',
            imgIcon: '/images/付款申请表单.svg',
            node: ['start', 'tianxieForm', 'kaifayuanShenpi', 'fbaYunyingzuzhangShenpi', 'yunyingjingliShenpi', 'zhuguanShenpi', 'caiwuShenpi', 'gongyinglianZhuguanShenpi', 'zongjingbanShenpi', 'fbaCaigouquerenShenpi', 'zhuguanQueren', 'end'],
            apiSubmitForm: '/sp/start-fba',
            apiReSubmitForm: '/sp/tianxieForm-fba/finish',
            needValidFormField: ['zhuguanUser.name', 'yunyingzuzhangUser.name', 'gongyinglianZhuguanUser.name'],
            useForm: ProcForm.yangpincaigouBeihuoshenqing,
        }, /*{
            subTitle: 'FBA确认申请',
            imgIcon: '/images/付款申请表单.svg',
            node: null,
            apiSubmitForm: '/sp/start-fba-queren',
            apiReSubmitForm: '/sp/tianxieForm-fba-queren/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.yangpincaigouBeihuoshenqing,
        },*/ {
            subTitle: '发货申请',
            imgIcon: '/images/付款申请表单.svg',
            node: ['start', 'tianxieForm', 'zhuguanShenpi', 'caiwuShenpi', 'fbaCaigouquerenShenpi', 'end'],
            apiSubmitForm: '/sp/start-fahuoshenqing',
            apiReSubmitForm: '/sp/tianxieForm-fahuoshenqing/finish',
            needValidFormField: ['jine', 'zhuguanUser.name'],
            useForm: ProcForm.fahuoshenqing,
        }]
    },
    {
        title: '周期结算',
        btns: [{
            subTitle: '服务器结算',
            imgIcon: '/images/会议费.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }, {
            subTitle: '租金水电结算',
            imgIcon: '/images/资产相关表单.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }, {
            subTitle: '工资',
            imgIcon: '/images/工资.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }, {
            subTitle: '社保',
            imgIcon: '/images/社保.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }, {
            subTitle: '公积金',
            imgIcon: '/images/公积金.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }, {
            subTitle: '分摊费用',
            imgIcon: '/images/分摊费用.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }, {
            subTitle: '物流费结算',
            imgIcon: '/images/物流.svg',
            node: nodeJiesuan,
            apiSubmitForm: '/sp/start-jiesuan',
            apiReSubmitForm: '/sp/tianxieForm-jiesuan/finish',
            needValidFormField: ['shoukuan', 'jine', 'zhuguanUser.name'],
            useForm: ProcForm.jiesuan,
        }]
    },
    {
        title: '出勤休假',
        btns: [{
            subTitle: '出差申请',
            imgIcon: '/images/出差.svg',
            node: ['start', 'tianxieForm', 'zhuguanShenpi', 'renshiShenpi', 'end'],
            useForm: ProcForm.renshi,
            apiSubmitForm: '/sp/start-cqxj',
            apiReSubmitForm: '/sp/tianxieForm-cqxj/finish',
        }]
    }
]
export default {
    info: Info,
    find(title, subTitle) {
        let res;
        let item = Info.find(item => {
            return item.title === title
        })
        if (item)
            res = item.btns.find(subItem => {
                return subItem.subTitle === subTitle
            })
        return res;
    },
    procImgs() {
        let imgs = [];
        Info.forEach(proc => {
            imgs = imgs.concat(Array.from(proc.btns, btn => {
                return `/images/proc/${proc.title}-${btn.subTitle}.jpg`;
            }))
        })
        return imgs;
    }
};
